import axios from "axios";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { SuccessDTO } from "../../dto";

type DeletePoetryQuizAnswerProps = {
  id: number;
};

let body: SuccessDTO;

export async function deletePoetryQuizAnswerAction(props: DeletePoetryQuizAnswerProps) {
  const token = localStorage.getItem("token");

  return await axios
    .delete(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/quiz-answers/delete/${props.id}`,
      {
        headers: {
          "Content-Type": "application/json",
          "app-platform": "cms",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(async (res) => {
      body = plainToClass(SuccessDTO, res.data);
      await validate(body);
      const errors = await validate(body);
      if (errors.length > 0) {
        throw errors;
      }

      return res.data;
    });
}
